import { bool, object, ref, string } from "yup";
import moment from "moment";

export const codeNumberMask = [/[0-9]/, /\d/, /\d/, "-", /\d/, /\d/, /\d/];
export const snilsNumberMask = [
  /[0-9]/,
  /\d/,
  /\d/,
  "-",
  /\d/,
  /\d/,
  /\d/,
  "-",
  /\d/,
  /\d/,
  /\d/,
  " ",
  /\d/,
  /\d/
];

const phoneNumberSchema = string()
  .typeError("Должно быть числом")
  .matches(/^[0-9]{11,12}$/, "Формат номера телефона не корректный")
  .nullable();

const stringVal = string()
  .matches(/^[\D]+$/, "Поле может содержать только буквенное значение")
  .nullable();
const numbergVal = string().matches(/^[0-9]+$/, "Должно быть числом");

const passpCodeReplace = (item) => {
  return item ? item.replace(/-|_/g, "").length === 6 : false;
};

export const validationsSignIn = object().shape({
  phone: phoneNumberSchema,
  password: string()
    .required("Введите пароль")
    .min(6, "Пароль должен быть не менее 6 символов")
});

export const validationPhone = object().shape({
  phone: phoneNumberSchema.required("Введите номер телефона")
});

export const validationCode = object().shape({
  code: string().required("Введите код")
});

export const validationRegistration = object().shape({
  surname: stringVal.required("Введите фамилию"),
  firstname: stringVal.required("Введите имя"),
  patronymic: stringVal,
  birthday: string()
    .test(
      "birthday",
      "Агентом может стать только человек, достигший 20 лет",
      (value) => {
        return moment().diff(moment(value), "years") >= 20;
      }
    )
    .required("Введите дату рождения"),
  phone: phoneNumberSchema.required("Введите номер телефона"),
  password: string()
    .required("Введите пароль")
    .min(6, "Пароль должен быть не менее 6 символов"),
  confirmPassword: string()
    .oneOf([ref("password")], "Пароли не совпадают")
    .required("Подтвердите пароль"),
  email: string()
    .required("Введите email")
    .test("email", "Введите корректный email", (value) => {
      if (!value) return false;
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(value);
    }),
  processingData: bool()
    .required()
    .oneOf([true], "Условия должны быть приняты"),
  contract: bool().required().oneOf([true], "Условия должны быть приняты")
});

export const validationProfile = object().shape({
  surname: stringVal.required("Введите фамилию"),
  firstname: stringVal.required("Введите имя"),
  patronymic: stringVal,
  birthday: string()
    .test(
      "birthday",
      "Агентом может быть только человек, достигший 20 лет",
      (value) => {
        return moment().diff(moment(value), "years") >= 20;
      }
    )
    .required("Введите дату рождения"),
  phone: phoneNumberSchema.required("Введите номер телефона"),
  birth_place: stringVal,
  passport_number: numbergVal.max(10, "Номер должен быть не более 10 символов"),
  passport_series: numbergVal.max(10, "Серия должна быть не более 10 символов"),
  passport_code: string(),
  passport_date: string(),
  passport_place: string(),
  passport_propiska: string(),
  snils: string().min(14, "Номер должен быть не менее 11 цифр"),
  inn: numbergVal.max(50, "Номер должен быть не более 50 символов"),
  bankaccount: numbergVal.max(50, "Номер должен быть не более 50 символов"),
  bankname: stringVal,
  bank_recipient: string(),
  bankbik: numbergVal.max(9, "БИК должен быть не более 9 символов"),
  bankkpp: numbergVal.max(20, "Номер должен быть не более 20 символов"),
  bankkor: numbergVal.max(25, "Номер должен быть не более 25 символов"),
  banknumber: numbergVal.max(12, "Номер должен быть не более 12 символов"),
  password: string().min(6, "Пароль должен быть не менее 6 символов"),
  confirmPassword: string().when("password", {
    is: (value) => value && value.length > 0,
    then: string()
      .required("Подтвердите пароль")
      .oneOf([ref("password")], "Пароли не совпадают"),
    otherwise: string()
  }),
  email: string()
    .required("Введите email")
    .test("email", "Введите корректный email", (value) => {
      if (!value) return false;
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(value);
    })
});

export const refreshUserDataMain = object().shape({
  surname: stringVal.required("Введите фамилию"),
  name: stringVal.required("Введите имя"),
  patronymic: stringVal,
  birthday: string()
    .test(
      "birthday",
      "Агентом может быть только человек, достигший 20 лет",
      (value) => {
        return moment().diff(moment(value), "years") >= 20;
      }
    )
    .required("Введите дату рождения"),
  phone: phoneNumberSchema,

  password: string().min(6, "Пароль должен быть не менее 6 символов"),
  confirmPassword: string().when("password", {
    is: (value) => value && value.length > 0,
    then: string()
      .required("Подтвердите пароль")
      .oneOf([ref("password")], "Пароли не совпадают"),
    otherwise: string()
  }),
  email: string()
    .required("Введите email")
    .test("email", "Введите корректный email", (value) => {
      if (!value) return false;
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(value);
    })
});

export const refreshUserDataFiles = object().shape({
  contract_type: string().required("Выберите тип сотрудничества"),
  birth_place: stringVal,

  passport_number: numbergVal
    .max(10, "Номер должен быть не более 10 символов")
    .required("Заполните все данные паспорта"),
  passport_series: numbergVal
    .max(10, "Серия должна быть не более 10 символов")
    .required("Заполните все данные паспорта"),
  passport_code: string()
    .required("Заполните все данные паспорта")
    .test("code", "Введите корректный код", (val) => {
      if (val) {
        return val.replace(/_|-/g, "").length === 6;
      }
    }),
  passport_date: string()
    .required("Заполните все данные паспорта")
    .test("date", "Дата не может быть больше сегодняшней", (val) => {
      if (val) {
        const date = new Date(val);
        return moment().diff(date, "days") >= 0;
      } else return true;
    }),
  passport_propiska: string()
    .trim()
    .min(1, "Поле не может быть пустым")
    .required("Заполните все данные паспорта"),
  passport_place: string()
    .trim()
    .min(1, "Поле не может быть пустым")
    .test("passport", "Заполните все данные паспорта", function (item) {
      return (
        this.parent.passport_number &&
        this.parent.passport_series &&
        passpCodeReplace(this.parent.passport_code) &&
        this.parent.passport_date &&
        this.parent.passport_propiska &&
        item &&
        item.trim().length > 1
      );
    }),

  snils: string()
    .required("Введите СНИЛС")
    .test("snils-digits", "Номер должен быть не менее 11 цифр", (val) => {
      const digits = (val || "").replace(/\D/g, "");
      return digits.length === 11;
    }),
  inn: numbergVal
    .required("Введите ИНН")
    .max(50, "Номер должен быть не более 50 символов"),
  bankaccount: numbergVal.max(20, "Номер должен быть не более 20 символов"),
  bankname: stringVal,
  bank_recipient: string(),
  bankbik: numbergVal.max(9, "БИК должен быть не более 9 символов"),
  bankkpp: numbergVal.max(20, "Номер должен быть не более 20 символов"),
  bankkor: numbergVal.max(25, "Номер должен быть не более 25 символов"),
  banknumber: numbergVal.max(12, "Номер должен быть не более 12 символов")
});
